import { useQuery } from '@tanstack/react-query';

import getCurrentShift from 'Api/monitoring/getCurrentShift';

import getCurrentShiftResponse from './model/response/getCurrentShiftResponse';

const useGetCurrentShift = () => {
  return useQuery({
    queryKey: ['shift'],
    queryFn: async () => {
      const response = await getCurrentShift();

      const result = getCurrentShiftResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetCurrentShift;
